<template>
  <div>
    <div class="mt-30">
      <van-form @submit="clickSubmit">
        <van-field
          v-model="userInfo.name"
          placeholder="请输入姓名"
          label="姓名"
          class="ft-26"
          :rules="[{ required: true, message: '请输入姓名' }]"
        />
        <van-field
          v-model="userInfo.idnum"
          placeholder="请输入身份证号"
          label="身份证号"
          class="ft-26"
          :rules="[
            { required: true, message: '请输入身份证号' },
            { validator: numValidator, message: '身份证号输入有误' },
          ]"
        />
        <van-field
          v-model="userInfo.tel"
          placeholder="请输入手机号码"
          label="手机号码"
          class="ft-26"
          :rules="[
            { required: true, message: '请输入手机号码' },
            { validator: phoneValidator, message: '手机号码输入有误' },
          ]"
        />
        <div class="mineInfo-btn">
          <van-button
            type="primary"
            color="#f5f5f5"
            class="blue-common-btn"
            block
            >修改</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { getUserInfo, modifyUserInfo } from "@/api/index";
import { Toast } from "vant";
export default {
  name: "mineInfo",
  data() {
    return {
      userInfo: {},
    };
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      let userInfo = this.$store.state.userModel.userInfo
        ? JSON.parse(JSON.stringify(this.$store.state.userModel.userInfo))
        : {};

      getUserInfo().then((res) => {
        this.userInfo = res.data || {};
        this.userInfo = Object.assign(userInfo, this.userInfo);
      });
    },
    phoneValidator(val) {
      return /^1[3456789]\d{9}$/.test(val);
    },
    numValidator(val) {
      return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val);
    },
    clickSubmit() {
      let params = JSON.parse(JSON.stringify(this.userInfo));

      modifyUserInfo(params).then((res) => {
        delete params.code;
        this.$store.commit("SET_USERINFO", params);
        Toast.success("修改成功");
        this.$router.push("/MTAw/mine");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.van-field__label {
  font-size: 30px;
  color: #333;
}
.van-field__control {
  font-size: 30px;
}
.mineInfo-btn {
  width: 90%;
  margin: 60px auto;
}
</style>
